import { render, staticRenderFns } from "./UserResearch.vue?vue&type=template&id=1d84c8c8&scoped=true"
import script from "./UserResearch.vue?vue&type=script&lang=js"
export * from "./UserResearch.vue?vue&type=script&lang=js"
import style0 from "./UserResearch.vue?vue&type=style&index=0&id=1d84c8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84c8c8",
  null
  
)

export default component.exports